module.exports = __webpack_public_path__ + "img/presentation-qr_code.55cd0ab4.png";